import React, { useState, useEffect } from "react";
import { Button, Row, Skeleton, Col, Tag } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";

import { useGetAdviseeDetails } from "apis/advisee";

import Title from "components/Title/Title";

import { constructDisplayPrice } from "utils/general";
import {
  buildPPSNewOwnedPoliciesUri,
  buildPPSOwnedPolicyDetailsUri,
} from "utils/routes";

import { PoliciesTable } from "./OwnedPolicies.styles";
import Locale from "react-intl-universal";

// const columns = [
//   {
//     title :"Poliy Number",
//     dataIndex :"policyNumber",
//     key :"policyNumber",
//   },
//   {
//     title: 'Plan Name',
//     dataIndex: "name",
//     key: "name",
//     render: (value, record) => {
//       return (
//         <Row gutter={4}>
//           <Col>{value}</Col>
//           <Col>
//             {record.coveredFor && <Tag color="orange">{record.coveredFor}</Tag>}
//           </Col>
//         </Row>
//       );
//     },
//   },
//   {
//     title: 'Company Name',
//     dataIndex: "company",
//     key: "company",
//   },
//   {
//     title: "Type of Plan",
//     dataIndex: "type",
//     key: "type",
//   },
//   {
//     title: 'Commencement Date',
//     dataIndex: "commencementDate",
//     key: "commencementDate",
//     render: (value) => value || "-",
//   },
//   {
//     title: 'Monthly Premium',
//     dataIndex: "monthlyPremium",
//     key: "monthlyPremium",
//     render: (value) => constructDisplayPrice(value || 0, false),
//   },
//   {
//     title: 'Status',
//     dataIndex: "status",
//     key: "status",
//   },
// ];

const OwnedPolicies = () => {
  const columns = [
    {
      title: Locale.get("ownedPolicies.newPolicyForm.policyNo"),
      dataIndex: "policyNumber",
      key: "policyNumber",
    },
    {
      title: Locale.get("ownedPolicies.newPolicyForm.policyName"),
      dataIndex: "name",
      key: "name",
      render: (value, record) => {
        return (
          <Row gutter={4}>
            <Col>{value}</Col>
            <Col>
              {record.coveredFor && (
                <Tag color="orange">{record.coveredFor}</Tag>
              )}
            </Col>
          </Row>
        );
      },
    },
    {
      title: Locale.get("ownedPolicies.newPolicyForm.companyName"),
      dataIndex: "company",
      key: "company",
    },
    {
      title: Locale.get("ownedPolicies.newPolicyForm.planType"),
      dataIndex: "type",
      key: "type",
    },
    {
      title: Locale.get("ownedPolicies.newPolicyForm.commencementDate"),
      dataIndex: "commencementDate",
      key: "commencementDate",
      render: (value) => value || "-",
    },
    {
      title: Locale.get("ownedPolicies.newPolicyForm.monthlyPremium"),
      dataIndex: "monthlyPremium",
      key: "monthlyPremium",
      render: (value) => constructDisplayPrice(value || 0, false),
    },
    {
      title: Locale.get("ownedPolicies.newPolicyForm.status"),
      dataIndex: "status",
      key: "status",
    },
  ];

  const { id: adviseeId } = useParams();
  const history = useHistory();

  const {
    isLoading: isAdviseeDetailsLoading,
    data: personalDetails,
  } = useGetAdviseeDetails(adviseeId, {});
  const isConstantsLoading = isAdviseeDetailsLoading;

  const handleOnRow = (record) => {
    return {
      onClick: () => {
        history.push(buildPPSOwnedPolicyDetailsUri(adviseeId, record._id));
      },
    };
  };

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Title>{Locale.get("ownedPolicies.pageTitle")}</Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push(buildPPSNewOwnedPoliciesUri(adviseeId))}
        >
          {Locale.get("ownedPolicies.newPolicyForm.addNewPolicyButton")}
        </Button>
      </Row>
      {isConstantsLoading ? (
        <Skeleton active />
      ) : (
        <PoliciesTable
          columns={columns}
          dataSource={personalDetails.policies}
          onRow={handleOnRow}
          pagination={false}
          rowKey={(record) => record._id}
        />
      )}
    </div>
  );
};

export default OwnedPolicies;
